<template>
  <div>
    <div style="margin-top: 10px;">
      <b-button-group>
        <b-button
          size="sm"
          variant="flat-primary"
          @click="step.isExpanded=!step.isExpanded"
        >
          <feather-icon :icon="step.isExpanded ? 'ChevronDownIcon' : 'ChevronRightIcon'" />
        </b-button>
        <b-button
          size="sm"
          :disabled="!canUp"
          :variant="canUp ? 'flat-primary' : 'flat-secondary'"
          @click="stepUp()"
        >
          <feather-icon icon="ArrowUpIcon" />
        </b-button>
        <b-button
          size="sm"
          :disabled="!canDown"
          :variant="canDown ? 'flat-primary' : 'flat-secondary'"
          @click="stepDown()"
        >
          <feather-icon icon="ArrowDownIcon" />
        </b-button>
      </b-button-group>
      <b-button-group>
        <div style="margin-left:10px;">
          <b-form-checkbox
            v-model="step.isActive"
            name="check-button"
            switch
            inline
            class="custom-control-success"
          />
        </div>
      </b-button-group>
      <b-button-group>
        <span v-if="!isEditName">{{ step.name }}</span>
        <b-form-input
          v-else
          v-model="step.name"
        />
        <b-button
          size="sm"
          variant="flat-primary"
          @click="isEditName = !isEditName"
        >
          <feather-icon icon="Edit3Icon" />
        </b-button>
        <b-button
          size="sm"
          variant="flat-danger"
          @click="onDelete"
        >
          <feather-icon icon="TrashIcon" /> Delete
        </b-button>
      </b-button-group>
    </div>
    <cbs-collapse :trigger="step.isExpanded">
      <div style="margin-top: 5px; margin-bottom: 15px;">
        <small class="text-secondary">Operand:</small>
        <v-select
          v-if="opers"
          v-model="step.operand"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          label="title"
          :options="opers"
          size="sm"
          placeholder="Select Operand..."
          @input="onSelectOperand($event)"
        >
          <template
            slot="option"
            slot-scope="item"
          >
            {{ item.title }}
            <small class="text-muted"><i>({{ item.value }})</i></small>
          </template>
        </v-select>
        <div v-if="step.operand">
          <div v-if="step.operand.sid === 'query' || step.operand.sid === 'query_large'">
            <b-row class="mt-1">
              <b-col>
                <small class="text-secondary">Object:</small>
                <v-select
                  v-if="refObject"
                  v-model="step.object"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="refObject"
                  size="sm"
                  placeholder="Select Object..."
                />
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col
                md="6"
                xl="4"
              >
                <b-form-group>
                  <small class="text-secondary">Sheet name:</small>
                  <b-form-input
                    v-model="step.sheetname"
                    placeholder="Sheet name"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="6"
                xl="4"
              >
                <b-form-group>
                  <small class="text-secondary">Row index:</small>
                  <b-form-input
                    v-model="step.rowindex"
                    placeholder="Row index"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="6"
                xl="4"
              >
                <b-form-group>
                  <small class="text-secondary">Column index:</small>
                  <b-form-input
                    v-model="step.colindex"
                    placeholder="Column index"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mt-0">
              <b-col>
                <small class="text-secondary">Cell Styles:</small>
                <v-select
                  v-model="step.styletype"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="styletypes"
                  size="sm"
                  placeholder="Select Style type..."
                />
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col>
                <small class="text-secondary">Query filter:</small>
                <div style="border:solid #cccccc 1px; border-radius: 5px; padding-left:10px; padding-right: 10px;padding-bottom:10px;">
                  <cbs-filter
                    :filter="step.queryFilter"
                    :fields="queryFields()"
                    :param-fields="paramFields()"
                  />
                </div>
              </b-col>
            </b-row>
            <cbs-data-reference
              entitysid="object"
              hide
              @load="onLoadRefObject"
            />
            <cbs-data-object
              v-if="step.object && step.object.value"
              hide
              :objectid="step.object.value"
              @load="onLoadQueryObject"
            />
          </div>
          <div v-else-if="step.operand.sid === 'formula'">
            <b-row class="mt-1">
              <b-col>
                <small class="text-secondary">Formula:</small>
                <cbs-reference-picker-sid
                  :value-container="step"
                  value-name="formula"
                  entitysid="formula"
                  placeholder="Select Formula..."
                />
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col
                md="6"
                xl="4"
              >
                <b-form-group>
                  <small class="text-secondary">Sheet name:</small>
                  <b-form-input
                    v-model="step.sheetname"
                    placeholder="Sheet name"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="6"
                xl="4"
              >
                <b-form-group>
                  <small class="text-secondary">Row index:</small>
                  <b-form-input
                    v-model="step.rowindex"
                    placeholder="Row index"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="6"
                xl="4"
              >
                <b-form-group>
                  <small class="text-secondary">Column index:</small>
                  <b-form-input
                    v-model="step.colindex"
                    placeholder="Column index"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </div>
          <div v-else-if="step.operand.sid === 'hidesheet'">
            <b-row class="mt-1">
              <b-col>
                <small class="text-secondary">Sheet Name:</small>
                <b-form-input
                  v-model="step.sheetname"
                  placeholder="Value"
                />
              </b-col>
            </b-row>
          </div>
          <div v-else-if="step.operand.sid === 'custom'">
            <b-row class="mt-1">
              <b-col>
                <small class="text-secondary">Custom procedure:</small>
                <b-form-input
                  v-model="step.sheetname"
                  placeholder="Value"
                />
              </b-col>
            </b-row>
          </div>
          <div v-else-if="step.operand.sid === 'multisheet'">
            <b-row class="mt-1">
              <b-col>
                <small class="text-secondary">Object:</small>
                <v-select
                  v-if="refObject"
                  v-model="step.object"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="refObject"
                  size="sm"
                  placeholder="Select Object..."
                  @input="onSelectMultisheetObject"
                />
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col>
                <small class="text-secondary">Filter:</small>
                <div style="border:solid #cccccc 1px; border-radius: 5px; padding-left:10px; padding-right: 10px;padding-bottom:10px;">
                  <cbs-filter
                    :filter="step.filter"
                    :fields="multisheetFields()"
                    :param-fields="paramFields()"
                  />
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col>
                <small class="text-secondary">Group By:</small>
                <div style="border:solid #cccccc 1px; border-radius: 5px; padding-left:10px; padding-right: 10px;padding-bottom:10px;">
                  <cbs-groupby
                    :groupby="step.groupby"
                    :fields="multisheetFields()"
                    :result-fields="multisheetFields()"
                  />
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col>
                <small class="text-secondary">Order By:</small>
                <div style="border:solid #cccccc 1px; border-radius: 5px; padding-left:10px; padding-right: 10px;padding-bottom:10px;">
                  <cbs-orderby
                    :orderby="step.orderby"
                    :fields="multisheetFields()"
                  />
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col
                md="6"
                xl="4"
              >
                <b-form-group>
                  <small class="text-secondary">Template Sheet:</small>
                  <b-form-input
                    v-model="step.template_sheet"
                    placeholder="Template sheet name"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="6"
                xl="4"
              >
                <b-form-group>
                  <small class="text-secondary">Start Sheet Index:</small>
                  <b-form-input
                    v-model="step.start_sheet_index"
                    type="number"
                    placeholder="0"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col>
                <small class="text-secondary">Sheet Name Constructor (argument):</small>
                <cbs-argument
                  :value="step.sheet_name"
                  :entity="{ datatype: { sid: 'string' } }"
                  @change="v => { step.sheet_name = v }"
                />
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col>
                <small class="text-secondary">Sub Report:</small>
                <v-select
                  v-if="refObject"
                  v-model="step.sub_report"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="refObject"
                  size="sm"
                  placeholder="Select Sub Report..."
                />
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col>
                <small class="text-secondary">Param Record:</small>
                <div style="border:solid #cccccc 1px; border-radius: 5px; padding-left:10px; padding-right: 10px;padding-bottom:10px;">
                  <cbs-modification-set
                    v-if="step.param_record"
                    :value="step.param_record"
                    :fields="subReportFields()"
                    :param-fields="multisheetAndObjectFields()"
                  />
                </div>
              </b-col>
            </b-row>
            <cbs-data-reference
              entitysid="object"
              hide
              @load="onLoadRefObject"
            />
            <cbs-data-object
              v-if="step.object && step.object.value"
              hide
              :objectid="step.object.value"
              @load="onLoadMultisheetObject"
            />
            <cbs-data-object
              v-if="step.sub_report && step.sub_report.value"
              hide
              :objectid="step.sub_report.value"
              @load="onLoadSubReportObject"
            />
          </div>
        </div>
      </div>
    </cbs-collapse>
    <cbs-debug :context="this" />
  </div>
</template>

<script>
import {
  BButton, BButtonGroup, BCol, BFormCheckbox, BFormGroup, BFormInput, BRow,
} from 'bootstrap-vue'
import CbsCollapse from '@/cubus/components/collapsible/CbsCollapse.vue'
import vSelect from 'vue-select'
import CbsDataReference from '@/cubus/components/reference/CbsDataReference.vue'
import CbsFilter from '@/cubus/components/filter/CbsFilter.vue'
import useCubus from '@/cubus/services/useCubus'
import CbsDataObject from '@/cubus/components/query/CbsDataObject.vue'
import CbsDebug from '@/cubus/components/debug/CbsDebug.vue'
import CbsReferencePickerSid from '@/cubus/components/reference/CbsReferencePickerSid.vue'
import CbsGroupby from '@/cubus/components/groupby/CbsGroupby.vue'
import CbsOrderby from '@/cubus/components/orderby/CbsOrderby.vue'
import CbsArgument from '@/cubus/components/argument/CbsArgument.vue'
import CbsModificationSet from '@/cubus/components/modification/CbsModificationSet.vue'

export default {
  name: 'CbsReportConfigStep',
  components: {
    CbsReferencePickerSid,
    CbsDebug,
    CbsDataObject,
    CbsCollapse,
    BFormCheckbox,
    BButton,
    BButtonGroup,
    BFormInput,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    CbsDataReference,
    CbsFilter,
    CbsGroupby,
    CbsOrderby,
    CbsArgument,
    CbsModificationSet,
  },
  props: {
    step: {
      type: Object,
      default: null,
    },
    index: {
      type: Number,
      default: null,
    },
    opers: {
      type: Array,
      default: null,
    },
    canUp: {
      type: Boolean,
      default: false,
    },
    canDown: {
      type: Boolean,
      default: false,
    },
    object: {
      type: Object,
      default: null,
    },
    paramRecord: {
      type: Object,
      default: null,
    },
  },
  emits: [
    'moveUp',
    'moveDown',
    'delete',
  ],
  data() {
    return {
      isEditName: false,
      refObject: null,
      queryObject: null,
      multisheetObject: null,
      subReportObject: null,
      refFormula: null,
      styletypes: [
        {
          title: 'No Styles',
          value: 'nostyle',
        },
        {
          title: 'First Row',
          value: 'firstrow',
        },
      ],
    }
  },
  methods: {
    stepUp() {
      // console.log('step up 1')
      this.$emit('moveup', this.index)
    },
    stepDown() {
      // console.log('step down 1')
      this.$emit('movedown', this.index)
    },
    onLoadRefObject(ref) {
      this.refObject = ref
    },
    onLoadRefFormula(ref) {
      this.refFormula = ref
    },
    onLoadQueryObject(obj) {
      this.queryObject = obj
    },
    onLoadMultisheetObject(obj) {
      this.multisheetObject = obj
    },
    onSelectMultisheetObject() {
      this.multisheetObject = null
    },
    onLoadSubReportObject(obj) {
      this.subReportObject = obj
    },
    subReportFields() {
      if (this.subReportObject) {
        return this.subReportObject.attributes.map(a => useCubus.attributeToField(a))
      }
      return []
    },
    queryFields() {
      if (this.queryObject) {
        return this.queryObject.attributes.map(a => useCubus.attributeToField(a))
      }
      return []
    },
    multisheetFields() {
      if (this.multisheetObject) {
        return this.multisheetObject.attributes.map(a => useCubus.attributeToField(a))
      }
      return []
    },
    paramFields() {
      if (this.object) {
        return this.object.attributes.map(a => useCubus.attributeToField(a))
      }
      return []
    },
    multisheetAndObjectFields() {
      console.log('paramFields', this.paramFields())
      console.log('multisheetFields', this.multisheetFields())
      const res = this.paramFields().concat(this.multisheetFields())
      console.log('multisheetAndObjectFields', res)
      // return res
      return this.paramFields().concat(this.multisheetFields())
    },
    onDelete() {
      this.$emit('delete')
    },
    onSelectOperand(v) {
      console.log('select operand', v)
      if (!v) {
        // this.step.operand = { value: null, sid: null, title: null }
        this.step.isActive = false
        if (this.step.formula) this.step.formula = null
      } else if (v.sid === 'formula') {
        this.$set(this.step, 'formula', null)
      } else if (v.sid === 'multisheet') {
        if (!this.step.start_sheet_index) this.$set(this.step, 'start_sheet_index', 0)
        if (!this.step.filter) this.$set(this.step, 'filter', useCubus.emptyFilter())
        if (!this.step.groupby) this.$set(this.step, 'groupby', { isActive: false, groups: [] })
        if (!this.step.orderby) this.$set(this.step, 'orderby', { isActive: false, sorts: [] })
        if (!this.step.sheet_name) this.$set(this.step, 'sheet_name', useCubus.emptyArgument())
        if (!this.step.param_record) this.$set(this.step, 'param_record', { isactive: false, list: [] })
      }
    },
  },
}
</script>

<style scoped>

</style>
